import React from 'react';
import * as SalesStore from 'pos/modules/main/SalesStore';
import { OrderingFacade } from 'pos/facades';
import { Result } from 'core/infrastructure';
import { Message } from 'core/ui-next/modal';
import { Res } from 'core/api';
import ShowPendingCardTransactionsStatus from 'pos/modules/helpers/payments-processing/PendingCardTransactionsStatus';

export default async function checkPendingCardTransactions(): Promise<Result<void>> {

	if (!SalesStore.getTicket().HasPendingTransactions)
		return Result.ok();

	const result = await Message.wait({
		message: Res.Msg.MSG_CHECK_PENDING_CARD_TRANSACTIONS(),
		action: () => OrderingFacade.processPendingCardTransactionStatus(SalesStore.getTicket().Id),
		onError: (_err) => Message.show(Res.Msg.MSG_CANNOT_CHECK_PENDING_TRANSACTION_STATUS(), { modalType: 'warning' })
	});

	if (result.ok) {
		await SalesStore.loadTicketById(SalesStore.getTicket().Id);
		await Message.show(<ShowPendingCardTransactionsStatus ticket={SalesStore.getTicket()} transactions={result.value} />);
	}

	if (!result.ok)
		return Result.error();

	return Result.ok();
}
